<template>
	<div id="DLoading" class="fullheight">
		<v-progress-circular color="primary" indeterminate :size="150" :width="10">
			<v-avatar :size="100" color="primary">
				<v-icon dark :size="75">mdi mdi-fridge</v-icon>
			</v-avatar>
		</v-progress-circular>
		<v-slide-y-reverse-transition appear>
			<p class="text-subtitle-1 mt-4">{{ $t("Loading.fetchingInformations") }}</p>
		</v-slide-y-reverse-transition>
	</div>
</template>

<script lang="ts">
import { mapGetters } from "vuex";
import AuthWrapper from "../services/wrappers/AuthWrapper";
import Vue from "vue";

export default Vue.extend({
	name: "DLoading",
	props: {
		redirect: {
			type: String,
			default: undefined,
		},
	},
	computed: {
		...mapGetters(["currentUser"]),
	},
	created() {
		if (this.currentUser) {
			this.replace();
		} else if (localStorage.getItem("token")) {
			this.getCurrentUser();
		} else {
			this.$router.replace({ name: "signIn" });
		}
	},
	methods: {
		async getCurrentUser() {
			try {
				await AuthWrapper.getCurrentUser();
				this.replace();
			} catch (e: any) {
				if (e.status === 401) {
					console.log("Need to login");
					this.$router.replace({ name: "signIn" });
				} else {
					console.error(e);
				}
			}
		},
		replace() {
			if (this.redirect) {
				this.$router.replace(this.redirect);
			} else {
				this.$router.replace({ name: "dashboard" });
			}
		},
	},
});
</script>

<style scoped>
#DLoading {
	display: flex;
	flex-flow: column;
	justify-content: center;
	align-items: center;
}
</style>
